"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.staticPix = void 0;
var QRCode = require("qrcode");
var utils_1 = require("./utils");
var getMerchantAccountInformation = function (pixKey, paymentDescription) {
    // Bank Domain
    var gui = utils_1.formatValue("MERCHANT_ACCOUNT_INFORMATION_GUI", "br.gov.bcb.pix");
    //   PIX Key
    var key = utils_1.formatValue("MERCHANT_ACCOUNT_INFORMATION_KEY", pixKey);
    var merchantAccountInformation = "" + gui + key;
    if (paymentDescription) {
        merchantAccountInformation += utils_1.formatValue("MERCHANT_ACCOUNT_INFORMATION_DESCRIPTION", paymentDescription);
    }
    return utils_1.formatValue("MERCHANT_ACCOUNT_INFORMATION", merchantAccountInformation);
};
var getAdditionalDataField = function (userTxid) {
    // TX ID
    var txId = utils_1.formatValue("ADDITIONAL_DATA_FIELD_TEMPLATE_TXID", userTxid);
    var additionalData = utils_1.formatValue("ADDITIONAL_DATA_FIELD_TEMPLATE", txId);
    return additionalData;
};
var getQrCodeFromPayload = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, QRCode.toDataURL(payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var staticPix = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, payloadAsString, crcResult, pixCopyAndPaste;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = [
                    utils_1.formatValue("PAYLOAD_FORMAT_INDICATOR", "01"),
                    getMerchantAccountInformation(params.pixKey, params.description),
                    utils_1.formatValue("MERCHANT_CATEGORY_CODE", "0000"),
                    utils_1.formatValue("TRANSACTION_CURRENCY", "986"),
                ];
                if (params.amount) {
                    payload.push(utils_1.formatValue("TRANSACTION_AMOUNT", params.amount));
                }
                payload = __spreadArrays(payload, [utils_1.formatValue("COUNTRY_CODE", "BR"), utils_1.formatValue("MERCHANT_NAME", params.merchant), utils_1.formatValue("MERCHANT_CITY", params.merchantCity)]);
                if (params.cep) {
                    payload.push(utils_1.formatValue("POSTAL_CODE", params.cep));
                }
                payload.push(getAdditionalDataField(params.transactionId));
                payload.push("6304");
                payloadAsString = payload.join("");
                crcResult = utils_1.getCRC16(payloadAsString);
                pixCopyAndPaste = "" + payloadAsString + crcResult;
                _a = {
                    payload: pixCopyAndPaste
                };
                return [4 /*yield*/, getQrCodeFromPayload(pixCopyAndPaste)];
            case 1: return [2 /*return*/, (_a.qrcode = _b.sent(),
                    _a)];
        }
    });
}); };
exports.staticPix = staticPix;
